<template>
	<div v-if="authed">
		<splitpanes horizontal class="default-theme" style="height:calc(100vh - 52px)" @resized="setTableHeight" v-resize="setTableHeight">
			<pane min-size="20" size="35" ref="toppane">
				<div>
					<v-data-table :headers="headers" :items="items" item-key="_id" v-model="selected"
						:options.sync="options" :server-items-length="totalItems"
						:footer-props="{ itemsPerPageOptions: [10, 30, 50] }" fixed-header :height="tableheight"
						:loading="loading" loading-text="加载中..." show-select single-select>
					<template v-slot:top>
						<div class="d-flex flex-wrap pt-3 pb-1 pl-1" style="gap:16px" ref="tabletopbar">
							<v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="10"
								transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="pdate1" label="预约日期起" readonly v-bind="attrs"
										v-on="on" dense hide-details clearable style="flex: 0 1 auto;max-width:150px;"></v-text-field>
								</template>
								<v-date-picker v-model="pdate1" @input="menu1 = false" no-title scrollable></v-date-picker>
							</v-menu>
							<v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="10"
								transition="scale-transition" offset-y min-width="290px">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="pdate2" label="预约日期止" readonly v-bind="attrs"
										v-on="on" dense hide-details clearable style="flex: 0 1 auto;max-width:150px;"></v-text-field>
								</template>
								<v-date-picker v-model="pdate2" @input="menu2 = false" no-title scrollable></v-date-picker>
							</v-menu>
							<v-text-field placeholder="姓名" v-model="pname" dense clearable hide-details style="flex: 0 1 auto"
								append-icon="search" @click:append="fetchData" @keyup.enter.native="fetchData"/>
						</div>
						<v-divider/>
					</template>
					<template v-slot:item.apntOprtDate="{ item }">
						{{formatTime(item.apntOprtDate)}}
					</template>

					<template v-slot:item.idcard="{ item }">
						{{getMaskedIdcard(item)}}
					</template>
					<template v-slot:item.gender="{ item }">
						{{getGender(item)}}
					</template>
					<template v-slot:item.age="{ item }">
						{{getAge(item)}}
					</template>
					<template v-slot:item.opts="{ item }">
						{{getOptsStr(item)}}
					</template>					</v-data-table>
				</div>
			</pane>
			<pane min-size="20" size="65" v-if="(selected.length > 0)">
<!--				<div style="max-height: 100%" class="overflow-y-auto pl-4 pt-4">-->
				<div class="paneemr-inner" :class="{'is-maximized':maximized}">
					<v-toolbar dense dark flat color="#e5da94">
						<v-app-bar-nav-icon @click.stop="onClickDrawer"></v-app-bar-nav-icon>
						<v-spacer></v-spacer>
						<v-btn icon @click.stop="toggleMaximize"><v-icon>mdi-reply</v-icon></v-btn>
					</v-toolbar>
					<div class="d-flex" style="position: relative;flex: 1;min-height: 0;">
						<div v-show="drawer" class="sideemr-menu">
							<v-list nav>
								<v-list-item :to="{path:'/emr/nursingrecord'}">护理记录单</v-list-item>
							</v-list>
						</div>
						<div class="pageemr-content">
							<router-view style="display:flex;flex-direction:column;height:calc(100vh - 50px);" :item="selected[0]"/>
						</div>
					</div>
<!--
					<v-btn color="primary" @click.stop="openNursingRecord">护理记录单</v-btn>
					<v-btn color="primary" class="ml-4" @click.stop="openSignTest">签名</v-btn>
-->
				</div>
			</pane>
		</splitpanes>
    </div>
    <div v-else>
        无此权限
    </div>
</template>

<script>
    import {formatTime, calculateAge, formatDate, addMonths, pathology_agencies} from '../utils'
    import { Splitpanes, Pane } from 'splitpanes'
    import 'splitpanes/dist/splitpanes.css'

    export default {
        data() {
            return {
                authed: false,
                headers: [
                    {text:'病案号', value:'pid', width:100},
                    {text:'姓名', value:'pii.username', width:100},
                    {text:'性别', value:'gender', width:80},
                    {text:'年龄', value:'age', width:80},
                    {text:'出生日期', value:'pii.dob', width:110},
                    {text:'套餐内容', value:'opts', width:180, sortable: false},
                    {text:'预约医生', value:'apntOprtDoctor', width:100},
                    {text:'预约手术时间', value:'apntOprtDate', width:180},
                    {text:'身高', value:'QA.baseinfo.bodyheight', width:80},
                    {text:'体重', value:'QA.baseinfo.bodyweight', width:80},
                    {text:'证件号', value:'idcard', width:120},
                    {text:'已选专家', value:'doctorName', width:100},
                    {text:'健康顾问', value:'consultantName', width:150},
                    {text:'订单号', value:'_id', width:100},
                ],
                items: [],
                loading: false,
				selected: [],
				options: {sortBy:['apntOprtDate'], sortDesc:[false]},
				totalItems: 0,
				tableheight: undefined,
				pdate1: '',
				menu1: false,
				pdate2: '',
				menu2: false,
				pname: '',
				maximized: false,
				drawer: true,
            }
        },
		created() {
			this.formatTime = formatTime;
		},
        mounted() {
			this.authed = this.$hasPrivilege('电子病历');
			if (!this.authed) return;
			this.pdate1 = formatDate(Date.now());
			this.pdate2 = formatDate(Date.now());
        },
        methods: {
			setTableHeight() {
				if (!this.$vuetify.breakpoint.mobile && this.selected.length === 0) {
					this.tableheight = undefined;
					return;
				}
				const tableFooterHeight = 59;
				const ttbh = this.$refs.tabletopbar.getBoundingClientRect().height;
				setTimeout(() => {
					const paneHeight = this.$refs.toppane.$el.getBoundingClientRect().height;
					this.tableheight = paneHeight - tableFooterHeight - ttbh;
					if (this.selected.length > 0) this.$nextTick(() => this.$vuetify.goTo(".v-data-table__selected", { container: ".v-data-table__wrapper" }) );
				}, 200)
			},
			getMaskedIdcard(item) {
				return item.pii.idcard;
			},
            getGender(item) {
                return item.pii.gender;
            },
            getAge(item) {
                return calculateAge(item.pii.dob);
            },
            getOptsStr(item) {
				return item.opts.ANES + item.opts.GIE + '/' + item.opts.PRO;
			},
			async fetchData() {
				const db = this.$tcbapp.database();
				const _ = db.command;
				let filter = [];
				const t1 = this.pdate1 ? new Date(this.pdate1 + 'T' + '00:00:00+08:00') : null;
				const t2 = this.pdate2 ? new Date(this.pdate2 + 'T' + '23:59:59+08:00') : null;
				if (t1 && t2) {
					filter.push({apntOprtDate:_.gt(t1).lt(t2)});
				} else if (this.pdate1) {
					filter.push({apntOprtDate:_.gt(t1)});
				} else if (this.pdate2) {
					filter.push({apntOprtDate:_.lt(t2)});
				} else {
					filter.push({apntOprtDate:_.exists(true)});
				}
				if (this.pname) {
					filter.push({'pii.username':this.pname});
				}
				filter.push({hide:_.neq(true)});
				const f = filter;
				this.loading = true;
				try {
                    const countRes = await db.collection('wp2order').where(_.and(f)).count();
					this.totalItems = countRes.total;
					const { sortBy, sortDesc, page, itemsPerPage } = this.options;
					const res = await db.collection('wp2order').where(_.and(f)).orderBy(sortBy[0]||'_', sortDesc[0] ? 'desc' : 'asc')
						.skip((page-1) * itemsPerPage).limit(itemsPerPage)
						.get();
					this.items = res.data;
				} catch(err) {
					console.error(err);
				}
				this.loading = false;
			},
			openNursingRecord() {
				window.tcb = this.selected[0];
				window.tcb.recordDate = new Date();
				window.open('/emr-nursing-record4.html', '_blank');
			},
			openSignTest() {
				window.open('/signtest.html', '_blank');
			},
			toggleMaximize() {
				this.maximized = !this.maximized;
			},
			onClickDrawer() {
				this.drawer = !this.drawer;
			},
		},
		watch: {
			options: {
				handler () {
					this.fetchData()
				},
				deep: true,
			},
			selected(newitem, olditem) {
				if (newitem.length === 0) return;
			},
			pdate1(newv, oldv) {
				if (newv && this.pdate2) {
					const t1 = this.pdate1 ? new Date(this.pdate1 + 'T' + '00:00:00+08:00') : null;
					const t2 = this.pdate2 ? new Date(this.pdate2 + 'T' + '23:59:59+08:00') : null;
					if (t1 > t2) {
						this.pdate2 = newv;
					}
				}
				this.fetchData();
			},
			pdate2(newv, oldv) {
				if (newv && this.pdate1) {
					const t1 = this.pdate1 ? new Date(this.pdate1 + 'T' + '00:00:00+08:00') : null;
					const t2 = this.pdate2 ? new Date(this.pdate2 + 'T' + '23:59:59+08:00') : null;
					if (t1 > t2) {
						this.pdate1 = newv;
					}
				}
				this.fetchData();
			},
		},
        components: { Splitpanes, Pane }
    }
</script>

<style>
.splitpanes.default-theme .splitpanes__pane {
    background-color: white;
}
.splitpanes.default-theme .splitpanes__splitter {
    background-color: #eee;
}
.splitpanes.default-theme .splitpanes__splitter:after,
.splitpanes.default-theme .splitpanes__splitter:before {
    background-color: rgba(0, 0, 0, .25);
}
.default-theme.splitpanes--horizontal>.splitpanes__splitter,
.default-theme .splitpanes--horizontal>.splitpanes__splitter {
    height: 8px;
}
.default-theme.splitpanes--horizontal>.splitpanes__splitter:after,
.default-theme .splitpanes--horizontal>.splitpanes__splitter:after,
.default-theme.splitpanes--horizontal>.splitpanes__splitter:before,
.default-theme .splitpanes--horizontal>.splitpanes__splitter:before {
    width: 60px;
    height: 1.5px
}
.v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-left: 16px;
}
.bcicon {
	padding: 0!important;
}
.edres {
	max-width:64px;
	display:inline-block;
}
.paneemr-inner {
	position: relative;
	max-height: 100%;
	background: #fff;
	overflow: auto;
}
.paneemr-inner.is-maximized {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 9999;
	background: #fff;
	overflow: auto;
}
.sideemr-menu {
	width: 256px;
	flex: 0 0 256px;
	overflow-y: auto;
}
.pageemr-content {
	flex: 1 1 auto;
	min-width: 0;
	overflow: auto;
}
</style>

<style scoped>
.edres >>> input {
	text-align: right;
}
</style>
